


























import { Prop, Component, Vue } from "vue-property-decorator";
import ProjectWorkerTableItem from "@/viewmodels/project-worker-table-item";

@Component({
  props: {
    selectable: {
      type: Boolean
    },
    removable: {
      type: Boolean
    },
    invitable: {
      type: Boolean
    }
  }
})
export default class ProjectWorkerTable extends Vue {
  @Prop({ default: () => [] }) selectedIds!: number[];
  @Prop({ default: () => [] }) items!: ProjectWorkerTableItem[];
  @Prop({ default: () => false }) customField!: boolean;

  created() {
    this.items = this.items.filter(item => item.isHiddenInfo === 0); // Fillter Staff is_hidden_info
  }

  get fields() {
    let fields = [
      { key: "name", label: "名前" },
      { key: "tel", label: "電話番号" },
      { key: "email", label: "メール" },
      { key: "worktype", label: "業種" },
      { key: "companyName", label: "社名" },
      { key: "inviteStatus", label: "招待" },
      { key: "actions", label: "" }
    ];
    if (this.$props.selectable) {
      fields.unshift({ key: "id", label: "" });
    }

    if (this.customField) {
      fields.splice(2, 0, {
        key: "scheduleNotification",
        label: "チャット通知"
      });
    }

    return fields;
  }

  get currentSelectedIds(): number[] {
    return this.selectedIds;
  }

  set currentSelectedIds(selectedIds: number[]) {
    this.$emit("select", selectedIds);
  }

  remove(id: number) {
    this.$emit("remove", id);
  }

  invite(id: number) {
    this.$emit("invite", id);
  }

  // custom class for tbody tr
  setTbodyTrClass(item: any) {
    const classes = [];
    if (item.isHiddenInfo === 1) classes.push("table-secondary");
    return classes;
  }
}
